import './LanguagesStyle.css'
import { useAppDispatch } from "../../../../store/hooks";
import { bookEditorActions } from "../slice";
import { BookLanguage, Language } from "../../../../rest/models";
import { orderBy } from "../../../../utils";
import { ModelMap } from "../../../../rest/slice";
import { Select } from "../../../RequestRespectingInputs";
import { useRef } from 'react';

export function TranslationLanguagesEdit(props: Props)
{
    const appDispatch = useAppDispatch();
    const {source_language, book_languages, lang_models} = props;
    const selectRef = useRef<HTMLSelectElement|null>(null);

    //IDs of the languages for the book's translations.
    const translationLanguageIds = book_languages
        .map(bl => bl.language)
        .filter(blid => blid !== source_language);

    /** Finds all languages not in this book. Sorts them by name. */
    function getLangsWithoutSource()
    {
        const lm2 = {...lang_models};
        delete lm2[source_language];
    
        const lm3 = Object.values(lm2);
        const lm4 = orderBy(lm3, l => l.name);
    
        return lm4;
    }

    //Languages that can be selected as translation languages.
    let possibleTranslationLanguages = getLangsWithoutSource();

    /*
        The default behavior for a multiline select is to allow multiple selections 
        only if the user is holding down Ctrl. Absurd, and unusable on phones.
        This overrides it.
    */
    function onOptionMouseDown(e: React.MouseEvent<HTMLOptionElement, MouseEvent>)
    {
        e.preventDefault();

        const opt = e.currentTarget;
        opt.selected = !opt.selected;
        const event = new Event('change', { bubbles: true, cancelable: true });
        opt.parentElement?.dispatchEvent(event);
        opt.parentElement?.focus();
    }

    //<option> elements for the <Select> below.
    const optionsForSelect = possibleTranslationLanguages.map(l => (
        <option key={l.key} value={l.key} onMouseDown={onOptionMouseDown}>
            {l.name}
        </option>));

    //Event handler for <Select onChange>.
    function onSelectChange(e: React.ChangeEvent<HTMLSelectElement>)
    {
        const select = e.currentTarget;
        const selectedLangs = Array
            .from(select.selectedOptions)
            .map(opt => opt.value);
        selectedLangs.push(props.source_language);
        appDispatch(bookEditorActions.setBookLanguages(selectedLangs));

        //For some reason, the select changes scroll position when I click on it.
        const scrollTop = e.currentTarget.scrollTop;
        window.setTimeout(function()
        {
            if (selectRef.current)
            {
                selectRef.current.scrollTop = scrollTop;
            }
        }, 1);
    }

    const notice = translationLanguageIds.length
        ? <></>
        : <div className='ernots_Notice'>
            You haven't selected any translation languages.
            They aren't required, and sometimes it makes sense not to have them.
            Just be sure you meant to do that.
        </div>

    return (
        <div className='ernots_TranslationLanguagesEdit'>
            <label htmlFor='translation_languages'>Translation languages</label>
            {notice}
            <Select id="translation_languages"
                    onChange={onSelectChange}
                    value={translationLanguageIds}
                    multiple={true}
                    ref={selectRef}>
                {optionsForSelect}
            </Select>
        </div>);
}

interface Props
{
    source_language: string;
    book_languages: BookLanguage[];
    lang_models: ModelMap<Language>;
}